import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { searchService } from 'shared/src/api/searchService';
import { useExperimentGroup } from 'shared/src/context/UserContext/useExperimentGroup';
import { useIsForegroundNow } from 'shared/src/hooks';
import { convertRenderDataToGoodsData } from 'shared/src/utils/convertRenderDataToGoodsData';
import { queryKey } from '../../../constants/queryKey';
import { isNotNil } from 'shared/src/utils';

/**
 * 검색 보조 화면 - 최근 본 검색 상품 추천 캐로셀 (EXP1802)
 * - B군일 때만 enabled → A(대조군)는 쿼리 미실행/캐로셀 미노출
 * - 아이템 render.data → GoodsData 변환은 select에서 1회 수행 (PDP useGoodsLikeRecommend 동일 패턴)
 */
export const useRecommendedGoods = () => {
  const isExperimentB = useExperimentGroup({
    sno: 'EXP1802',
    targetGroups: ['B'],
  });
  const isForeground = useIsForegroundNow();

  const query = useQuery({
    queryKey: queryKey.recommendedGoods(),
    queryFn: searchService.getRecommendedGoods,
    enabled: isExperimentB,
    select: data => ({
      ...data,
      item_list: data.item_list.map(item => ({
        ...item,
        ...convertRenderDataToGoodsData(
          { ...item, item: { ...item.item, hasAd: isNotNil(item.item.ad) } },
          {},
        ),
      })),
    }),
  });

  // 화면 재노출(viewDidAppear)마다 재호출 — 검색결과에서 상품 보고 복귀 시 최신 목록 갱신
  const { refetch } = query;
  useEffect(() => {
    if (isForeground && isExperimentB) {
      refetch();
    }
  }, [isForeground, isExperimentB, refetch]);

  return query;
};
